import $ from 'jquery';
import 'slick-carousel';


ready(qs('.CP-actu-wrapper'), () => {
    // ===== VARS =====
    const $cp = qs('.CP-actu-wrapper-slick');
    const $pushes = qsa($cp, 'li');
    const wrapper = $('.CP-actu-wrapper-slick');
    const $nav = qs('.CP-actu-nav')
    const slickSettings = {
        arrows: false,
        dots: false,
        variableWidth: true,
    };
    // ===== FUNCTIONS ===== 
    const setPushsHeight = () => {
        let maxHeight = 0;
        qsa('.CP-actu-push').forEach(push => {
            if (push.clientHeight > maxHeight) maxHeight = push.clientHeight;
        });
        qsa('.CP-actu-push').forEach(push => push.style.height = `${maxHeight}px`);
    }
    const updateNavStyle = () => {
        const push = {
            w: $pushes[$pushes.length - 1].clientWidth,
            h: $pushes[$pushes.length - 1].clientHeight,
        }
        $nav.style.marginTop = `-${push.h + 30}px`;
        $nav.style.marginLeft = `${push.w + 60}px`;
        if (window.innerWidth >= 1200 )$nav.style.marginLeft =  `${push.w * 2  + 60 * 2}px`;
    }
    const mobileBehavior = () => {
        setPushsHeight();
        wrapper.slick(slickSettings);
        wrapper.slicked = true;
        $nav.style.marginTop = ''
        $nav.style.marginLeft = '';
    };
    const desktopBehavior = () => {
        setPushsHeight();
        updateNavStyle()
        // destroy slick
        if (wrapper && wrapper.slicked) {
            $(wrapper).slick('unslick');
            wrapper.slicked = false; 
        }
    };
    const behavior = () => {
        if (window.innerWidth < 1024) {
            mobileBehavior();
        } else {
            desktopBehavior();
        }
       
    }
    behavior();
    window.addEventListener('resize', () => {
        behavior()
    })
})



// WEBPACK FOOTER //
// ./src/scripts/components/ActusWrapper.js